export const APP_NAME = 'DashDen'

export const ROUTES = {
  HOME: '/',
  HUB: '/hub',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  GAME: '/game',
  GAME_SETUP: '/game/setup',
  MATH_SETUP: '/math/setup',
  MATH_GAME: '/math/game',
  WORD_PUZZLE_SETUP: '/word-puzzle/setup',
  WORD_PUZZLE_GAME: '/word-puzzle/game',
  LANGUAGE: '/language',
  LANGUAGE_SETUP: '/language/setup',
  LANGUAGE_GAME: '/language/game',
  LANGUAGE_RESULTS: '/language/results',
  SUDOKU_SETUP: '/sudoku/setup',
  SUDOKU_GAME: '/sudoku/game',
  PUZZLE_SETUP: '/puzzle/setup',
  PUZZLE_GAME: '/puzzle/game',
  BUBBLE_POP_SETUP: '/bubble-pop/setup',
  BUBBLE_POP_GAME: '/bubble-pop/game',
  SEQUENCE_MEMORY_SETUP: '/sequence-memory/setup',
  SEQUENCE_MEMORY_GAME: '/sequence-memory/game',
  CODE_A_BOT_SETUP: '/code-a-bot/setup',
  CODE_A_BOT_GAME: '/code-a-bot/game',
  GEO_QUIZ_SETUP: '/geo-quiz/setup',
  GEO_QUIZ_GAME: '/geo-quiz/game',
  HISTORY_QUIZ_SETUP: '/history-quiz/setup',
  HISTORY_QUIZ_GAME: '/history-quiz/game',
  CIVICS_QUIZ_SETUP: '/civics-quiz/setup',
  CIVICS_QUIZ_GAME: '/civics-quiz/game',
  COLOR_BY_NUMBER_SETUP: '/color-by-number/setup',
  COLOR_BY_NUMBER_GAME: '/color-by-number/game',
  HANGMAN_SETUP: '/hangman/setup',
  HANGMAN_GAME: '/hangman/game',
  TIC_TAC_TOE_SETUP: '/tic-tac-toe/setup',
  TIC_TAC_TOE_GAME: '/tic-tac-toe/game',
  SCRATCH_CODING_SETUP: '/scratch-coding/setup',
  SCRATCH_CODING_GAME: '/scratch-coding/game',
  MATH_MAZE_SETUP: '/math-maze/setup',
  MATH_MAZE_GAME: '/math-maze/game',
  RATE_LIMIT: '/rate-limit',
  SUBSCRIPTION: '/subscription',
  DASHBOARD: '/dashboard',
  STATISTICS: '/dashboard/statistics',
  HISTORY: '/dashboard/history',
  ACHIEVEMENTS: '/dashboard/achievements',
  LEADERBOARD: '/leaderboard',
  PROFILE: '/profile',
  CONTACT: '/contact',
  ADMIN: '/admin',
} as const

export const GAME_THEMES = [
  { id: 'ANIMALS', name: 'Animals', emoji: '🐶' },
  { id: 'FRUITS', name: 'Fruits', emoji: '🍎' },
  { id: 'VEHICLES', name: 'Vehicles', emoji: '🚗' },
  { id: 'SPACE', name: 'Space', emoji: '🚀' },
  { id: 'OCEAN', name: 'Ocean', emoji: '🐠' },
  { id: 'FORMULA1', name: 'Formula 1', emoji: '🏎️' },
] as const

export const DIFFICULTY_LEVELS = [
  { id: 'EASY', name: 'Easy', pairs: 6, description: '6 pairs - Perfect for beginners' },
  { id: 'MEDIUM', name: 'Medium', pairs: 8, description: '8 pairs - A good challenge' },
  { id: 'HARD', name: 'Hard', pairs: 10, description: '10 pairs - For memory masters' },
] as const

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',
  USER: 'user',
  GAME_SETTINGS: 'game_settings',
} as const

export const QUERY_KEYS = {
  USER: 'user',
  GAME: 'game',
  GAME_HISTORY: 'game_history',
  STATISTICS: 'statistics',
  ACHIEVEMENTS: 'achievements',
} as const
